import moment from 'moment';

export const getAge = (date: string | Date) => {
  const dateMoment = moment(date);
  return moment().diff(dateMoment, 'years');
};

/** 'YYYY-MM-DD' -> a local Date at noon (safe for react-datepicker display). */
export const toPickerDate = (value?: string | Date | null): Date | undefined => {
  if (!value) return undefined;
  if (value instanceof Date) return value;
  const m = moment(value, 'YYYY-MM-DD', true);
  return m.isValid() ? m.hour(12).minute(0).second(0).toDate() : undefined;
};

/** picked Date -> 'YYYY-MM-DD' using its local calendar day (never toISOString). */
export const fromPickerDate = (date?: Date | null): string | undefined => {
  if (!date) return undefined;
  return moment(date).format('YYYY-MM-DD');
};
